import { ToastProvider } from '@perpay-web/components/base/ToastProvider/useToastContext';
import ComponentStackProviders from '@perpay-web/fintech/components/base/ComponentStackProviders/ComponentStackProviders';
import DataModuleProviders from '@perpay-web/fintech/components/base/DataModuleProviders/DataModuleProviders';
import ModalProviders from '@perpay-web/fintech/components/base/ModalProviders/ModalProviders';
import StepsProviders from '@perpay-web/fintech/components/base/StepsProviders/StepsProviders';
import { PerpayPlusSoloApplicationProvider } from '@perpay-web/fintech/components/composite/PerpayPlusSoloApplication/usePerpayPlusSoloApplicationContext';
import { CardApplicationProvider } from '@perpay-web/fintech/components/screens/CardApplication/useCardApplicationContext';
import { EditEmailProvider } from '@perpay-web/fintech/components/screens/EditEmail/useEditEmailContext';
import { EditPhoneProvider } from '@perpay-web/fintech/components/screens/EditPhone/useEditPhoneContext';
import { MarketplaceCardApplicationProvider } from '@perpay-web/fintech/components/screens/MarketplaceCardApplication/useMarketplaceCardApplicationContext';
import { CardMigrationProvider } from '@perpay-web/fintech/hooks/useCardMigrationContext';
import { UseProfileMFAContextProvider } from '@perpay-web/fintech/hooks/useProfileMFAContext';
import { VirtualProvisioningProvider } from '@perpay-web/fintech/hooks/useVirtualProvisioningContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const FintechGlobalProviders = createCombinedProvider(
    ComponentStackProviders,
    StepsProviders,
    ModalProviders,
    ToastProvider,
    CardApplicationProvider,
    MarketplaceCardApplicationProvider,
    DataModuleProviders,
    CardMigrationProvider,
    VirtualProvisioningProvider,
    EditEmailProvider,
    EditPhoneProvider,
    PerpayPlusSoloApplicationProvider,
    UseProfileMFAContextProvider,
);

export default FintechGlobalProviders;
